import { MapPin, Phone, ExternalLink, Clock } from "lucide-react";
import { FadeIn, MaskedLineScroll, Overline } from "@/components/Reveal";

const MAPS_URL =
  "https://www.google.com/maps/search/?api=1&query=34+boulevard+de+Polangis+94500+Champigny-sur-Marne";

export default function Showroom() {
  return (
    <section id="showroom" className="bg-bone py-24 md:py-32 border-b border-midnight/10" data-testid="showroom-section">
      <div className="max-w-7xl mx-auto px-5 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <Overline>Notre showroom</Overline>
          <h2 className="mt-4 font-display font-black uppercase tracking-tighter leading-[0.95] text-3xl sm:text-4xl lg:text-5xl">
            <MaskedLineScroll>Venez nous</MaskedLineScroll>
            <MaskedLineScroll delay={0.12}>rencontrer</MaskedLineScroll>
          </h2>
          <FadeIn delay={0.2}>
            <div className="mt-10 space-y-6">
              <div className="flex items-start gap-4">
                <MapPin size={20} strokeWidth={1.5} className="text-signal mt-1 shrink-0" />
                <div>
                  <p className="font-display font-extrabold uppercase tracking-tight text-lg">MSC Toitures</p>
                  <p className="text-midnight/70 mt-1" data-testid="showroom-address">
                    34 boulevard de Polangis<br />94500 Champigny-sur-Marne
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <Phone size={20} strokeWidth={1.5} className="text-signal mt-1 shrink-0" />
                <div className="space-y-1">
                  <a href="tel:0646300391" data-testid="showroom-phone-1" className="block font-display font-bold text-lg hover:text-signal transition-colors duration-300">06 46 30 03 91</a>
                  <a href="tel:0187078662" data-testid="showroom-phone-2" className="block font-display font-bold text-lg hover:text-signal transition-colors duration-300">01 87 07 86 62</a>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <Clock size={20} strokeWidth={1.5} className="text-signal mt-1 shrink-0" />
                <div>
                  <p className="font-display font-extrabold uppercase tracking-tight text-lg">Horaires</p>
                  <p className="text-midnight/70 mt-1" data-testid="showroom-hours">Du lundi au samedi<br />9h00 — 18h00</p>
                </div>
              </div>
              <p className="text-sm text-midnight/60 leading-relaxed max-w-md">
                Matériaux, tuiles, solutions de couverture et de zinguerie : passez nous voir pour parler
                de votre projet de vive voix, ou appelez-nous pour un déplacement gratuit à votre domicile.
              </p>
              <a
                href={MAPS_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="showroom-map-button"
                className="btn-sweep inline-flex items-center gap-3 bg-midnight text-white font-display font-bold text-sm uppercase tracking-wide px-8 py-4 transition-colors duration-300"
              >
                <ExternalLink size={16} strokeWidth={1.5} />
                Nous trouver
              </a>
            </div>
          </FadeIn>
        </div>
        <div className="lg:col-span-7">
          <FadeIn delay={0.25}>
            <div className="border border-midnight/10 bg-white p-2" data-testid="showroom-map">
              <iframe
                title="MSC Toitures — 34 boulevard de Polangis, 94500 Champigny-sur-Marne"
                src="https://www.google.com/maps?q=34+boulevard+de+Polangis,+94500+Champigny-sur-Marne&output=embed"
                className="w-full aspect-[4/3] grayscale hover:grayscale-0 transition-[filter] duration-700"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </FadeIn>
        </div>
      </div>
    </section>
  );
}
